import { render, staticRenderFns } from "./TemplateItemManager.vue?vue&type=template&id=31500c2f&scoped=true"
import script from "./TemplateItemManager.vue?vue&type=script&lang=js"
export * from "./TemplateItemManager.vue?vue&type=script&lang=js"
import style0 from "./TemplateItemManager.vue?vue&type=style&index=0&id=31500c2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31500c2f",
  null
  
)

export default component.exports